<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['selectOption']);
</script>

<template>
  <div
    class="tw-w-64 tw-flex tw-flex-col tw-py-14 tw-border-2 tw-rounded-xl tw-gap-8 tw-cursor-pointer tw-transition-all tw-duration-150 tw-ease-in"
    :class="[
      selected ? '!tw-border-primary tw-shadow-selected-box' : 'tw-border-grey-mid',
      disabled ? '!tw-border-grey-highlight tw-text-grey' : ''
    ]"
    @click="emit('selectOption')"
  >
    <span class="tw-p-3.5 tw-rounded-xl tw-self-center tw-bg-primary-100">
      <svg-vue
        class="tw-w-[72px] tw-h-[72px] tw-transition-colors tw-duration-150 tw-ease-in"
        :class="[
          disabled ? 'tw-text-primary/50' : 'tw-text-primary',
        ]"
        :icon="icon"
      />
    </span>
    <p
      class="tw-text-xl tw-px-3.5 tw-transition-all tw-duration-150 tw-ease-in"
      :class="[
        disabled ? 'tw-text-grey' : 'tw-text-grey-darkest',
      ]"
    >
      {{ title }}
    </p>
  </div>
</template>
